import capitalize from 'utils/string/capitalize';
import getLastPeriodForRange from 'utils/dateRange/getLastPeriodForRange';
import formatCustomPeriod from 'utils/dateRange/formatCustomPeriod';
import parseMetric from 'utils/webanalytics/parseMetric';
import _ from 'lodash';

_.noConflict();

function addProfilesToRequest (requestParams, profiles, goals) {
  requestParams.forEach(p => {
    p.profiles = [];
    p.goals = [];
    _.castArray(p.metrics).forEach(m => {
      const parsed = parseMetric(m);
      if (parsed.profileId) {
        p.profiles.push(parsed.profileId);
        return;
      }
      if (parsed.goalId) {
        p.goals.push(parsed.goalId);
        if (goals[parsed.goalId] && goals[parsed.goalId].profile_id) {
          const profileId = goals[parsed.goalId].profile_id;
          p.profiles.push(profileId);
        }
      }
    });
  });
}

function getRequestParamsForWidget (widget, dashboardParams, profiles, goals) {
  const dsType = widget.dsType;
  let dsParams = {...widget[`ds${capitalize(dsType)}Params`]};

  let requestParams = [dsParams];
  const requestParamsResult = {};
  if (dsType === 'orders') {
    requestParamsResult[dsType] = requestParams;
    return requestParamsResult;
  }

  if (dsParams.planFactMetrics) {
    dsParams.metrics = [
      ...dsParams.metrics,
      ...dsParams.planFactMetrics.map(m => m.metric)
    ];
  }

  if (dsParams.customPeriod && dsParams.customPeriod.period) {
    const period = formatCustomPeriod(
      dsParams.customPeriod.period,
      dsParams.customPeriod.createNewPeriod,
      widget.type === 'kpiChart'
    );

    dsParams.dateStart = period.dateStart;
    dsParams.dateEnd = period.dateEnd;
  }

  if (widget.type === 'metricChart') {
    const paramsCopy = {...dsParams, ...getLastPeriodForRange(dashboardParams)};

    // we need only total for previous period
    paramsCopy.dateGrouping = 'no';
    paramsCopy.sorting = null;
    requestParams.push(paramsCopy);
  }

  if (widget.type === 'periodsComparisonChart') {
    requestParams = [];
    if (dsParams.periods.firstPeriod.startDate) {
      const period = formatCustomPeriod(
        dsParams.periods.firstPeriod,
        false,
        false
      );
      const firstPeriodRequest = {...dsParams};
      firstPeriodRequest.dateStart = period.dateStart;
      firstPeriodRequest.dateEnd = period.dateEnd;

      requestParams.push(firstPeriodRequest);
    }
    if (dsParams.periods.secondPeriod.startDate) {
      const period = formatCustomPeriod(
        dsParams.periods.secondPeriod,
        false,
        false
      );
      const secondPeriodRequest = {...dsParams};
      secondPeriodRequest.dateStart = period.dateStart;
      secondPeriodRequest.dateEnd = period.dateEnd;

      requestParams.push(secondPeriodRequest);
    }
  }

  addProfilesToRequest(requestParams, profiles, goals);

  requestParamsResult[dsType] = [];
  requestParams.forEach(p => {
    requestParamsResult[dsType].push(p);
  });

  // request for orders (api/orders/periods/inherited) and statistics
  if (widget.type === 'kpiChart' && dsParams.filteringType === 'order_periods') {
    requestParams[0].id = widget.id;
    requestParamsResult.ordersAndStat = requestParams;
    delete requestParamsResult.statistics;
  }

  return requestParamsResult;
}

export default getRequestParamsForWidget;
